// @ts-nocheck
/* eslint-disable */

"use client";

import {
  BlogCard,
  Button,
  Chip,
  Column,
  EmptyState,
  Flex,
  Heading,
  Icon,
  Loader,
  ProjectCard,
  Row,
  ScrollingNav,
  Separator,
  Spacer,
} from "politicamente-informados-ds";
import { Suspense, useCallback, useEffect, useState } from "react";

import DisplayImage from "@/components/common/DisplayImage/DisplayImage";
import Link from "next/link";
import NavigationEvents from "@/components/common/NavigationEvents/NavigationEvents";
import displayBlock from "@/lib/wordpress/blocks/displayBlock";
import { formatDate } from "@/lib/helpers/dateFormate";
import { useGlobalContext } from "@/lib/globalContext";
import useMediaQuery from "@/lib/helpers/useMediaQuery";

const perPage = 12;

const BlogPage = (post: Record<string, unknown>) => {
  const state = useGlobalContext();
  const [filtersChange, setFiltersChange] = useState({
    page: 1,
  });
  const [loading, setLoading] = useState<boolean | null>(false);
  const [filteredPosts, setFilteredPosts] = useState<
    Record<string, unknown>[] | null
  >(post?.items ? post?.items : post?.grid?.items);
  const [showLoadMore, setShowLoadMore] = useState<boolean | null>(
    filteredPosts?.length < perPage ? false : true
  );

  const handleChange = useCallback(
    (filters) => {
      const currentPage = filtersChange.page;
      setLoading(true);
      setFiltersChange(filters);

      WpClientRequest({
        post_type: "projects",
        variables: {
          category: post?.items ? post.slug : "",
          limit: perPage,
          offset:
            currentPage !== filters.page ? perPage * (filters.page - 1) : 3,
        },
      }).then((res) => {
        const newItems =
          currentPage !== filters.page
            ? [...filteredPosts, ...res.items]
            : res.items;
        setFilteredPosts(newItems);
        setShowLoadMore(newItems.length === res.total ? false : true);
        setLoading(false);
      });
    },
    [filtersChange]
  );

  return (
    <div>
      <Suspense>
        <NavigationEvents translatedURI={post?.translatedURI} acf={{ page_style: "light" }} />
        {!!(post?.intro?.blocks as [])?.length &&
          (post?.intro?.blocks as []).map(
            (block: BlocksProps, index: number) => {
              return displayBlock(block, index);
            }
          )}
      </Suspense>
      <Row>
        <Column>
          <Flex align="center">
            <div className="flex-shrink-1">
              <Heading size="h1" tag="h1">
                {state?.dict?.post_types?.blog}
              </Heading>
            </div>
          </Flex>
          <Separator
            height="1px"
            color="var(--color-primary70)"
            className="mt-4 mb-6"
          ></Separator>

          <ScrollingNav align={"left"} className="mb-5">
            <div>
              <Link href={`/blog/`}>
                <Chip
                  variant={"light"}
                  hover={true}
                  style={
                    post?.title // title only exists in page not on taxonomy
                      ? {
                          color: "white",
                          backgroundColor: "var(--color-primary70)",
                        }
                      : {}
                  }
                >
                  {state?.dict?.common?.all}
                </Chip>
              </Link>
            </div>
            {post &&
              post.categories &&
              post.categories.map((category, i) => {
                return (
                  <div key={`filter-${category.slug}`}>
                    <Link href={`/blog/category/${category.slug as string}`}>
                      <Chip
                        variant={"light"}
                        hover={true}
                        style={
                          post?.slug === category.slug
                            ? {
                                color: "white",
                                backgroundColor: "var(--color-primary70)",
                              }
                            : {}
                        }
                      >
                        {category.name as string}
                      </Chip>
                    </Link>
                  </div>
                );
              })}
          </ScrollingNav>
        </Column>
      </Row>
      <Row>
        {loading ? (
          <Column className="text-center pt-5 pb-5">
            <Loader
              label={state?.dict?.common?.loading}
              variant="dark"
            ></Loader>
          </Column>
        ) : (
          <>
            {filteredPosts && filteredPosts.length !== 0 ? (
              <>
                <Suspense
                  fallback={
                    <Loader
                      label={state?.dict?.common?.loading}
                      variant="dark"
                    ></Loader>
                  }
                >
                  {filteredPosts.map(
                    (post: Record<string, unknown>, i: number) => {
                      if (!post) return false;

                      const category =
                        (post?.categories as Record<
                          string,
                          unknown | string
                        >) || [];
                      const categoryName =
                        category && category[0]
                          ? (category[0]?.terms[0]?.name as string)
                          : "";

                      const imageElement = (
                        <DisplayImage
                          url={post?.image as string}
                          alt={post?.title ? (post?.title as string) : ""}
                          fill={true}
                        />
                      );

                      return (
                        <Column key={`blogCard-${i}`} sm={12} md={6} lg={4}>
                          <BlogCard
                            date={formatDate(
                              post?.date as string,
                              "DATE_SHORT"
                            )}
                            category={categoryName}
                            imageElement={imageElement}
                            title={post.title}
                            description={post.excerpt}
                            author={post.author}
                            linkElement={
                              <Link
                                href={post.slug as string}
                                aria-label={`Read more about ${post.title}`}
                                role="link"
                                className="linker"
                              ></Link>
                            }
                          />
                        </Column>
                      );
                    }
                  )}

                  {showLoadMore && (
                    <Column className="text-center">
                      <Button
                        variant="secondary"
                        mode="light"
                        className="mt-5"
                        onClick={() => {
                          handleChange({
                            ...filtersChange,
                            page: filtersChange.page + 1,
                          });
                        }}
                      >
                        {state?.dict?.blog?.loadMore}
                      </Button>
                    </Column>
                  )}
                </Suspense>
              </>
            ) : (
              <Column className="pt-5 pb-5">
                <Spacer height={8}></Spacer>
                <EmptyState
                  variant={"light"}
                  label={state?.dict?.common?.noResults}
                ></EmptyState>
              </Column>
            )}
          </>
        )}
      </Row>
      <Spacer height={8} />
    </div>
  );
};
export default BlogPage;
